<template>
  <div id="app__ernest">
    <header class="app__header__ernest">
      <div>
        <v-icon>mdi-apps</v-icon>
      </div>
      <div>
        <div><span>{{ $t('app.ernestHeader.dashboard') }}</span></div>
        <div></div>
        <div></div>
        <div></div>
      </div>
      <div></div>
    </header>

    <section class="app__section__ernest">
      <p v-html="staticText"></p>
      <p>{{ $t('pages.dashboard.userCount', { userCount }) }}</p>
      <v-expansion-panels multiple>
        <v-expansion-panel v-for="questionnaire in questionnaireList" :key="questionnaire.id">
          <v-expansion-panel-header>
            <div>
              <p>{{ questionnaire.label }}<br/>
                <small v-if="user.isAdmin">{{ $t('pages.dashboard.managerName', { name: questionnaire.user}) }}</small>
              </p>
              <div class="publication">
                <p v-if="questionnaire.isPublished">
                  {{ $t('pages.dashboard.publishedAt', { date: questionnaire.publicationDate }) }}
                </p>
                <p v-else>{{ $t('pages.dashboard.unpublished')}}</p>
                <p>{{ $t('pages.dashboard.iterations.name')}}<br/>
                  <small>
                    {{ $t('pages.dashboard.iterations.globalStats', questionnaire.iterations)}}
                  </small>
                </p>
              </div>
            </div>
          </v-expansion-panel-header>
          <v-expansion-panel-content :eager="true">
            <v-btn @click="loadSkillCSV(questionnaire.id)">
              {{ $t('pages.dashboard.buttons.skillsImport') }}
            </v-btn>
            <v-btn @click="loadAnswerCSV(questionnaire.id)">
              {{ $t('pages.dashboard.buttons.answersImport') }}
            </v-btn>
            <h2 v-if="graphDisplay(questionnaire.iterations)">
              {{ $t('pages.dashboard.graph.title')}}
            </h2>

            <stat-chart :questionnaire="questionnaire"
                        v-if="graphDisplay(questionnaire.iterations)"/>
          </v-expansion-panel-content>
        </v-expansion-panel>
      </v-expansion-panels>
    </section>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import { _axios } from '@/plugins/axios'

const FileDownload = require('js-file-download')

export default {
  name: 'GestionnaireHome',
  components: {
    statChart: () => import('@/components/dashboard/chart')
  },
  data () {
    return {
      staticText: '',
      questionnaireId: null
    }
  },
  computed: {
    ...mapGetters('Dashboard', [
      'userCount',
      'questionnaires'
    ]),
    ...mapGetters('User', [
      'user'
    ]),
    questionnaireList () {
      return this.questionnaires.map(q => ({ ...q }))
    }
  },
  async created () {
    await _axios({
      method: 'GET',
      url: 'statictexts/gestionnaire_tableau_de_bord/'
    })
      .then(response => {
        this.staticText = response.data.text
      })

    await this.loadDashboardStats()
  },
  methods: {
    ...mapActions('Dashboard', [
      'loadDashboardStats'
    ]),
    async loadSkillCSV (questionnaireId) {
      await _axios.get(`questionnaires/${questionnaireId}/skills.csv/`)
        .then(response => {
          FileDownload(response.data, `skill_${questionnaireId}.csv`)
        })
    },
    async loadAnswerCSV (questionnaireId) {
      await _axios.get(`questionnaires/${questionnaireId}/answers.csv/`)
        .then(response => {
          FileDownload(response.data, `answer_${questionnaireId}.csv`)
        })
    },
    graphDisplay (iterations) {
      return iterations.finished > 0 && iterations.chartData.some(it => it.value > 0)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../assets/style/styleAppErnest";
  .publication {
    display: flex;
    justify-content: flex-start;
    p:first-child {
      min-width: 120px;
      margin-right: 20px;
    }
  }
  .v-expansion-panel-content {
    button:first-child {
      margin-right: 15px;
    }

    h2 {
      margin-top: 20px;
    }
    .chartStatDiv {
      margin-top: 20px;
    }
  }
</style>
